import React, { useEffect, useState } from "react";
import {addDoc, collection, serverTimestamp} from 'firebase/firestore';
import {db} from '../../firebase-config';
import { useNavigate } from "react-router-dom";
import {storage} from '../../firebase-config';
import {getDownloadURL, ref, uploadBytesResumable} from 'firebase/storage';
import {v4} from 'uuid';
import { safeGet } from "@firebase/util";
import styles from '../../Styles/createpost.css';

function CreatePost() {

    let navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [postText, setPostText] = useState("");
    const [postAuthor, setPostAuthor] = useState("");
    const [postFileLink, setPostFileLink] = useState("");
    const [postImageLink, setPostImageLink] = useState("");
    const postsCollectionRef = collection(db, "posts");
    
    const [imageUpload, setImageUpload] = useState("");
    const [fileUpload, setFileUpload] = useState("");
    const [fileNameUpload, setFileNameUpload] = useState("");

    // useEffect(() => postImageLink && alert(postImageLink), [postImageLink]);
    
    const uploadFile = () => {
        if(fileUpload == "")
        {
            setPostFileLink("nolink");
            setFileNameUpload("nolink");
            return;
        }

        const fileRef = ref(storage, `postFiles/${fileUpload.name + v4()}`);
        uploadBytesResumable(fileRef, fileUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                createPost(url, null);
            })
            console.log("uploaded");
        });
    }

    const uploadImage = () => {
        if(imageUpload == "")
        {
            setPostImageLink("nolink");
            return;
        }

        const imageRef = ref(storage, `postImages/${imageUpload.name + v4()}`);
        uploadBytesResumable(imageRef, imageUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                createPost(null, url);
            })
            console.log("uploaded");
        });
    }

    const uploadImageandFile = () => {
        if(imageUpload == "")
        {
            setPostImageLink("nolink");
            return;
        }

        const imageRef = ref(storage, `postImages/${imageUpload.name + v4()}`);
        const fileRef = ref(storage, `postFiles/${fileUpload.name + v4()}`);
        uploadBytesResumable(imageRef, imageUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((urlImage) => {
                uploadBytesResumable(fileRef, fileUpload).then((snapshot) => {
                    getDownloadURL(snapshot.ref).then((urlFile) => {
                        createPost(urlFile, urlImage);
                    })
                    console.log("uploaded");
                });
            })
            console.log("uploaded");
        });
    }

    const createPost = async (PFL, IFL) => {
            await addDoc(postsCollectionRef, {
            fileNameUpload, 
            title, 
            postText, 
            PostFileLink: PFL,
            PostImageLink: IFL,
            postAuthor, 
            createdAt: serverTimestamp()
        });
        navigate('/');
    }

    const submitPost = () => {
        console.log(imageUpload);
        console.log("submiting");

        if(imageUpload != "")
        {
            if(fileUpload != "")
            {
                uploadImageandFile();
                return;
            }else 
            {
                uploadImage();
                return;
            }
        }else if(fileUpload != "")
        {
            uploadFile();
            return;
        }else
        {
            createPost(null, null);
            return;
        }
    }

    useEffect(() => {
        if(!localStorage.getItem("isAuth"))
        {
            navigate('/');
        }
    }, []);

    return(
        <div className="createPostWrapper">
            <div className='createPostPage'>
                <div className="cpContainer">
                    <h1>Dodaj post</h1>
                    <div className="inputGp">
                        <label>Tytuł: </label>
                        <input placeholder="Tytuł..." onChange={(event) => {setTitle(event.target.value)}} />
                    </div>
                    <div className="inputGp">
                        <label>Post: </label>
                        <textarea placeholder="Post... " onChange={(event) => {setPostText(event.target.value)}} />
                    </div>
                    <div className="inputGp">
                        <label>Autor: </label>
                        <input placeholder="Autor..." onChange={(event) => {setPostAuthor(event.target.value)}} />
                    </div>
                    <div className="inputGp">
                        <label>Obraz: </label>
                        <input type="file" accept="image/*" onChange={(event) => {setImageUpload(event.target.files[0])}}/>
                    </div>
                    <div className="inputGp">
                        <label>Dodatkowy plik: </label>
                        <input type="file" onChange={(event) => {setFileUpload(event.target.files[0])}}/>
                    </div>
                    <div className="inputGp">
                        <label>Widoczna nzwa pliku: </label>
                        <input placeholder="Widoczna nazwa pliku..." onChange={(event) => {setFileNameUpload(event.target.value)}} />
                    </div>
                    <button onClick={submitPost} className="submbtn">Opublikuj</button>
                </div>
            </div>
        </div>
    );
}

export default CreatePost;

















/*import React, { useEffect, useState } from "react";
import {addDoc, collection, serverTimestamp} from 'firebase/firestore';
import {db} from '../../firebase-config';
import { useNavigate } from "react-router-dom";
import {storage} from '../../firebase-config';
import {getDownloadURL, ref, uploadBytesResumable} from 'firebase/storage';
import {v4} from 'uuid';
import { safeGet } from "@firebase/util";

function CreatePost() {

    let navigate = useNavigate();

    const [title, setTitle] = useState("");
    const [postText, setPostText] = useState("");
    const [postAuthor, setPostAuthor] = useState("");
    const [postFileLink, setPostFileLink] = useState("");
    const [postImageLink, setPostImageLink] = useState("");
    const postsCollectionRef = collection(db, "posts");
    
    const [imageUpload, setImageUpload] = useState("");
    const [fileUpload, setFileUpload] = useState("");
    const [fileNameUpload, setFileNameUpload] = useState("");

    // useEffect(() => postImageLink && alert(postImageLink), [postImageLink]);
    
    const uploadFile = () => {
        if(fileUpload == "")
        {
            setPostFileLink("nolink");
            setFileNameUpload("nolink");
            return;
        }

        const fileRef = ref(storage, `postFiles/${fileUpload.name + v4()}`);
        uploadBytesResumable(fileRef, fileUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                console.log(url);
                setPostFileLink(url.toString());
            })
            console.log("uploaded");
        });
    }

    const uploadImage = () => {
        if(imageUpload == "")
        {
            setPostImageLink("nolink");
            return;
        }

        const imageRef = ref(storage, `postImages/${imageUpload.name + v4()}`);
        uploadBytesResumable(imageRef, imageUpload).then((snapshot) => {
            getDownloadURL(snapshot.ref).then((url) => {
                setPostImageLink(url.toString());
                alert(setPostImageLink);
            })
            console.log("uploaded");
        });
    }

    const createPost = async () => {
        await addDoc(postsCollectionRef, {
            fileNameUpload, 
            title, 
            postText, 
            postFileLink,
            postImageLink,
            postAuthor, 
            createdAt: serverTimestamp()
        });
    }

    const submitPost = () => {
        console.log("submiting");
        uploadImage();
        uploadFile();
        createPost();
        alert(postImageLink);
        navigate('/');
    }

    useEffect(() => {
        if(!localStorage.getItem("isAuth"))
        {
            navigate('/');
        }
    }, []);

    return(
        <div className='createPostPage'>
            <div className="cpContainer">
                <h1>Dodaj post</h1>
                <div className="inputGp">
                    <label>Tytuł: </label>
                    <input placeholder="Tytuł..." onChange={(event) => {setTitle(event.target.value)}} />
                </div>
                <div className="inputGp">
                    <label>Post: </label>
                    <textarea placeholder="Post... " onChange={(event) => {setPostText(event.target.value)}} />
                </div>
                <div className="inputGp">
                    <label>Autor: </label>
                    <input placeholder="Autor..." onChange={(event) => {setPostAuthor(event.target.value)}} />
                </div>
                <div className="inputGp">
                    <label>Obraz: </label>
                    <input type="file" accept="image/*" onChange={(event) => {setImageUpload(event.target.files[0])}}/>
                </div>
                <div className="inputGp">
                    <label>Dodatkowy plik: </label>
                    <input type="file" onChange={(event) => {setFileUpload(event.target.files[0])}}/>
                </div>
                <div className="inputGp">
                    <label>Widoczna nzwa pliku: </label>
                    <input placeholder="Widoczna nazwa pliku..." onChange={(event) => {setFileNameUpload(event.target.value)}} />
                </div>
                <button onClick={submitPost}>Submit post</button>
            </div>
        </div>
    );
}

export default CreatePost;
*/